<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :show-close="false"
    custom-class="fifl-message-box"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <p
      class="booking-exist__message"
      v-html="message"
    />

    <span
      v-show="showNotice"
      class="booking-exist__notice"
    >
      취소 시 수강 횟수가 자동 복구됩니다.
    </span>

    <div class="booking-list-container">
      <ul v-if="!hasCustomSlot">
        <li
          v-for="(booking, bookingIndex) in bookings"
          :key="bookingIndex"
          :class="presentPreviousBookingClass(booking.dt)"
        >
          <span class="booking-list__date">
            - {{ presentDate(booking.dt) }}
          </span> <span class="booking-list__name">
            {{ booking.course_name }}
          </span>
        </li>
      </ul>
      <slot v-else />
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-show="cancelButtonText"
        class="white"
        @click="handleClickCancelButton"
      >
        {{ cancelButtonText }}
      </el-button>
      <el-button
        v-show="confirmButtonText"
        class="gray"
        @click="handleClickConfirmButton"
      >
        {{ confirmButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dateFns from 'date-fns';

export default {
  name: 'BookingExistWarningDialog',
  props: {
    hasSlot: {
      type: Boolean,
      default: false
    },
    confirmButtonText: {
      type: String,
      default: '확인'
    },
    cancelButtonText: {
      type: String,
      default: '취소'
    },
    bookings: {
      type: Array
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String
    },
    title: {
      type: String
    },
    isMarkingPreviousBooking: {
      type: Boolean,
      default: false
    },
    showNotice: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasCustomSlot() {
      return this.hasSlot;
    }
  },
  methods: {
    presentDate(dt) {
      return dateFns.format(dt, 'YYYY년 M월 D일 HH:mm');
    },
    presentPreviousBookingClass(date) {
      if (!this.isMarkingPreviousBooking) {
        return;
      }

      return {
        'booking-list__before': dateFns.isBefore(date, new Date())
      };
    },
    handleClickConfirmButton() {
      this.$emit('confirm');
    },
    handleClickCancelButton() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
.booking-exist__notice {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  letter-spacing: -0.6px;
  color: #4a4a4a;
  margin-top: 10px;
  display: inline-block;
}

.booking-exist__message {
  word-break: keep-all;
}

.booking-list-container {
  border-radius: 8px;
  background-color: #f2f2f2;
  height: 177px;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0 0;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  li {
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.booking-list__before {
      color: #224ba2;
    }

    .booking-list__date {
      display: inline-block;
      width: 143px;
      margin-right: 7px;
    }
  }
}
</style>
